(function ($) {
  mascaraModuleFormatterV1 = {
    formatter: $('.mascara-module-formatter-v1')
  };

  Drupal.behaviors.mascaraModuleFormatterV1 = {
    get: function (key) {
      return mascaraModuleFormatterV1[key];
    },

    set: function (key, val) {
      mascaraModuleFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var formatterPos = thisFormatter.offset();
        var $stickyHeader = thisFormatter.find('.mascara-module-sticky-header');
        var $window = $(window);
        var $header = $('#top');
        var headerPos = $header.css('top');
        var mainOffset = $('#main').offset();

        // Loop through the li menu items and add item-x class
        thisFormatter.find('.mascara-module-formatter-header').find('.mascara-menu li').each(function (i) {
          $(this).addClass('item-' + (i + 1));
          var a = $(this).find('a');

          a.on('click', function(e) {
            e.preventDefault();
            // Get item-x class from clicked "a"
            var thisClass = $(this).parent().attr('class').split(' ').pop();

            // Add/remove active class on click
            $(this).toggleClass('active');
            // Remove active class from "a" siblings
            $(this).parent().siblings('li').find('a').removeClass('active');
            // Find matching rows with thisClass, add show class and show it
            thisFormatter.find('.mascara-module-formatter-rows').find('.row.' + thisClass).addClass('show').show();
            // Hide all rows without the thisClass class, remove class show and hide it
            thisFormatter.find('.mascara-module-formatter-rows').find('.row').not('.' + thisClass).removeClass('show').hide();
            // Close any open quickshop window
            thisFormatter.find('.mascara-module-formatter-rows').find('#quickshop').remove();
          // Hide caret
          // thisFormatter.find('.mascara-module-row-v1 .caret').addClass('hidden');
          });
        });

        // On page load set the third (Fullest Volume) menu item to active
        thisFormatter.find('.mascara-module-formatter-header').find('.mascara-menu').find('li.item-3').find('a').addClass('active');

        // Loop through the row items and add item-x class
        thisFormatter.find('.mascara-module-formatter-rows').find('.row').each(function (i) {
          $(this).addClass('item-' + (i + 1));
          // Hide all but item-3 (Fullest Volume)
          $(this).not('.item-3').hide();
          // If this has class show, show it
          $('.show', this).show();
        });
      });
    }
  };
})(jQuery);
